export default __webpack_public_path__ + "static/about-cover-alt-33bcd225fb9e6d9b4b1c641612ba9e2d.jpg";